// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lJVEC","top":"styles_top__37Q_b"};